package com.macrofocus.common.geom

class Dimension : Dimension2D {
    val iwidth : Int
    val iheight : Int

    constructor() {
        this.iwidth = 0
        this.iheight = 0
    }
    constructor(width: Int, height: Int) {
        this.iwidth = width
        this.iheight = height
    }

    override val width: Double
        get() = iwidth.toDouble()
    override val height: Double
        get() = iheight.toDouble()

    override fun toString(): String {
        return "Dimension.Integer{" +
                "width=" + width +
                ", height=" + height +
                '}'
    }
}
